/**
 * API Configuration
 */
export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';
export const WS_URL = import.meta.env.VITE_WS_URL || 'http://localhost:3000';

/**
 * Routes
 */
export const ROUTES = {
  HOME: '/',
  TERMINAL: '/terminal',
  MAIL: '/mail'
};

/**
 * Auth Types
 */
export const AUTH_TYPES = {
  TELEGRAM: 'telegram',
  TOKEN: 'token',
  DEBUG: 'debug'
};
